/** @file saveDownload: hands the browser a URL or text as a file download through a temporary anchor. */

/** Downloads `source` (a URL, or text saved as a Blob of `mime`) as `filename`; object URLs are revoked afterwards. */
export function saveDownload(filename: string, source: { url: string } | { text: string; mime: string }): void {
  const url = 'url' in source ? source.url : URL.createObjectURL(new Blob([source.text], { type: source.mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.append(a);
  a.click();
  a.remove();
  if (!('url' in source)) setTimeout(() => { URL.revokeObjectURL(url); }, 0);
}
